/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../../model/order';
import '../../../../connect/v2/resources/error';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "service": {
                "nested": {
                  "RetrieveInternalOrderRequest": {
                    "fields": {
                      "orderNumber": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "RetrieveInternalOrderResponse": {
                    "fields": {
                      "order": {
                        "type": "squareup.solidshop.model.Order",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": "squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE RetrieveInternalOrderRequest @ squareup/solidshop/v2/service/orders/retrieve_internal_order.proto at 11:1
 */
export const RetrieveInternalOrderRequest = $root.lookupType('squareup.solidshop.v2.service.RetrieveInternalOrderRequest');
fixType(RetrieveInternalOrderRequest);
Builder.createAndAttachToType(RetrieveInternalOrderRequest);
/**
 * SOURCE RetrieveInternalOrderResponse @ squareup/solidshop/v2/service/orders/retrieve_internal_order.proto at 15:1
 */
export const RetrieveInternalOrderResponse = $root.lookupType('squareup.solidshop.v2.service.RetrieveInternalOrderResponse');
fixType(RetrieveInternalOrderResponse);
Builder.createAndAttachToType(RetrieveInternalOrderResponse);
